import type { ToastAlertProps } from '@frameio/vapor';
import { ToastAlert } from '@frameio/vapor';
import { IconNotifications } from '@frameio/vapor-icons';

/**
 * ToastAlert wrapper dedicated to notifications. It includes the Notification
 * icon as adornmentBefore.
 */
export const Toast = ({
  title,
  variant = 'neutral',
  onRequestClose,
  adornmentAfter,
  closeLabel,
}: Pick<
  ToastAlertProps,
  'title' | 'adornmentAfter' | 'onRequestClose' | 'variant' | 'closeLabel'
>) => (
  <ToastAlert
    adornmentAfter={adornmentAfter}
    adornmentBefore={<IconNotifications />}
    closeLabel={closeLabel}
    onRequestClose={onRequestClose}
    title={title}
    variant={variant}
  />
);
